






import Vue from "vue";

export default Vue.extend({
  components: {},
  data() {
    return {
      loading: true,
      reason: ""
    };
  },
  async mounted() {
    const query = this.$route.query;
    const authRequestID = query["authRequestID"];
    const pamHostName = query["pamHostName"];
    window.location.href = '/open-id-connect-provider/oauth/authorize/callback?' +
        `access_token=${sessionStorage.getItem(`OIDC-TOKEN-${pamHostName}`)}&id=${authRequestID}`
  }
});
